<template>
  <div class="list-page">
    <div class="header-con">
      <div class="tabs-con">
        <div class="tab tab1" :class="{active: tabs==='SETTLED'}" @click="changeTabs('SETTLED')">已到账</div>
        <div class="tab tab2" :class="{active: tabs==='WAIT_SETTLE'}" @click="changeTabs('WAIT_SETTLE')">待结算</div>
      </div>
    </div>

    <div class="list-con">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="isError"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <list v-for="(item, i) in list" :key="i" :itemData="item"/>
        </van-list>
      </van-pull-refresh>
    </div>


  </div>
</template>

<script>
import { getOrderRewardLogs } from '@/api/mall/mallSettle'
import list from './components/item'
export default {
  components: {
    list,
  },
  data(){
    return{
      tabs: 'SETTLED',//SETTLED-已结算；WAIT_SETTLE-待结算
      refreshLoading: false,
      loading: false,
      finished: false,
      isError: false,
      page: 1,
      size: 10,
      list: [],
    }
  },
  created(){

  },
  methods: {
    changeTabs(type){
      this.tabs = type
      this.onRefresh()
    },

    onRefresh(){
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.list = [];
        this.refreshLoading = false;
        window.scrollTo(0, 10);
      },100)
    },
    onLoad() {
      getOrderRewardLogs({
        tabs: this.tabs,
        page: this.page,
        size: this.size
      }).then(res => {
        let items = res.data.items || []
        if(items.length){
          if (this.page === 1){this.list = [];}
          this.list = this.list.concat(items)
          this.page++
        } else {
          this.finished = true
        }
        this.loading = false
      }).catch(() => {
        this.loading = false;
        this.error = true;
      })
    },


  }
}
</script>

<style lang="less" scoped>
.list-page{
  position: relative;width: 100%;height: 100%;
  .header-con{
    display: flex;justify-content: center;align-items: center;
    height: 58px;width: 100%;background-color: #f4f4f4;
    .tabs-con{
      width: 150px;display: flex;
      .tab{
        flex: 1;height: 35px;color: #999;font-size: 14px;background-color: #fff;
        display: inline-flex;justify-content: center;align-items: center;
        &.tab1{border-top-left-radius: 18px;border-bottom-left-radius: 18px;}
        &.tab2{border-top-right-radius: 18px;border-bottom-right-radius: 18px;}
        &.active{color: #fff;background-color: #1585f3; }
      }
    }
  }
  .list-con{
    position: absolute;z-index: 0;top: 58px;left: 0;right: 0;bottom: 0;
    overflow-y: auto;
  }
}
</style>